module.exports = __webpack_public_path__ + "img/circle-user.2fad9ac3.svg";